import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { LibModule } from '@usitsdasdesign/dds-ng';
import { WelcomeComponent } from './welcome/welcome.component';
import { HOME_DATA } from './data';
import { VideoComponent } from '../../shared/video/video.component';
import { HomeService } from './home.service';
import { MediaService } from '../../shared/services/media.service';
import { MediaHandlerService } from '../../shared/services/media-handler.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    WelcomeComponent,
    LibModule,
    VideoComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  homePageData: any;
  private mediaObserver: MutationObserver;
  constructor(private homeService: HomeService,
    private mediaService: MediaService,
    private elRef: ElementRef,
    private mediaHandlerService: MediaHandlerService) {
  }

  ngOnInit(): void {
    this.getHomeData();
    this.mediaHandlerService.processMedia(this.elRef.nativeElement, 'poster');
    this.mediaHandlerService.processMedia(this.elRef.nativeElement, 'video');
    this.mediaObserver = this.mediaHandlerService.observeMedia(this.elRef.nativeElement, (type) => this.mediaHandlerService.processMedia(this.elRef.nativeElement, type));
  }

  private getHomeData() {
    this.homeService.getData().subscribe(response => {
      this.homePageData = response?.[0];
    })
  }

  ngOnDestroy(): void {
    if (this.mediaObserver) {
      this.mediaObserver.disconnect();
    }
  }

}
